import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { savePermissionData, updatePermissionData } from '../../services/permission';

const AddPermission = (props) => {
    const [isLoading, setLoading] = useState(false);
    let validationShape = {
        name: Yup.string().required().label('Name'),
        category: Yup.string().required().label('Category'),
        portal: Yup.string().required().label('Portal'),
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: props.fillData,
        enableReinitialize: true,
        validationSchema: Yup.object(validationShape),
        onSubmit: (values) => {
            if (props.getId !== 0) {
                updatePermission(props.getId, values);
            } else {
                savePermission(values);
            }
        }
    });


    const savePermission = (values: any) => {
        setLoading(true);
        savePermissionData({
            "name": values.name,
            "category": values.category,
            "portal_id": values.portal
        }).then(function (res) {
            const resp = res.data;
            setLoading(false);
            if (resp.Acknowledge == 1) {
                toast.success('Permission Added Successfully!');
                props.setShow(false);
                props.loadList();
            } else if (resp.FullMessage != "") {
                setLoading(false);
                toast.error(resp.FullMessage);
            }
        }).catch(err => {
            setLoading(false);
            toast.error('Internal Server Error!');
        });
    };

    const updatePermission = (id: number, values: any) => {
        setLoading(true);
        updatePermissionData(id, {
            "name": values.name,
            "category": values.category,
            "portal_id": values.portal
        }).then(function (res) {
            const resp = res.data;
            setLoading(false);
            if (resp.Acknowledge == 1) {
                toast.success('Permission updated Successfully!');
                props.setShow(false);
                props.loadList();
            } else if (resp.FullMessage != "") {
                setLoading(false);
                toast.error(resp.FullMessage);
            }
        }).catch(err => {
            setLoading(false);
            toast.error('Internal Server Error!');
        });
    };

    return (
        <>
            <Modal show={props.show} onHide={props.handleClose} size="lg">
                {(props.isPopLoading || isLoading) && <div className="overlay">
                    <i className="fas fa-2x fa-sync fa-spin"></i>
                </div>}
                <Modal.Header closeButton>
                    <Modal.Title>{props.getId !== 0 ? 'Edit' : 'Add'} Permissions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Row>
                            <Form.Group className='col-md-6'>
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    name="name"
                                    type="text"
                                    placeholder="Enter name"
                                    value={values.name}
                                    onChange={handleChange}
                                    isValid={touched.name && !errors.name}
                                    isInvalid={touched.name && !!errors.name}
                                />
                                {touched.name && errors.name ? (
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                ) : ''}
                            </Form.Group>

                            <Form.Group className='col-md-6'>
                                <Form.Label>Category</Form.Label>
                                <Form.Control
                                    name="category"
                                    type="text"
                                    placeholder="Enter category"
                                    value={values.category}
                                    onChange={handleChange}
                                    isValid={touched.category && !errors.category}
                                    isInvalid={touched.category && !!errors.category}
                                />
                                {touched.category && errors.category ? (
                                    <Form.Control.Feedback type="invalid">
                                        {errors.category}
                                    </Form.Control.Feedback>
                                ) : ''}
                            </Form.Group>

                            <Form.Group className='col-md-6'>
                                <Form.Label>Select Portal</Form.Label>
                                <select name="portal" className='form-control' onChange={handleChange} value={values.portal}>
                                    <option value="">Select portal</option>
                                    {
                                        props.portalData.length > 0 && props.portalData.map((row: any, podidx: number) => (
                                            <option value={row.id}>{row.name}</option>
                                        ))
                                    }
                                </select>
                                {errors.portal ? (<div className='validation-error'>{errors.portal} </div>) : ''}
                            </Form.Group>

                        </Form.Row>

                        <Button variant="primary" type="submit">
                            {props.getId !== 0 ? 'Update' : 'Add'} Permission
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddPermission;
